import * as actionTypes from '../../../modules/actions'
import { setDefault } from '../../../modules/formatting'

const initialState = {
  loading: true,
  error: '',
}

export default (state = initialState, action) => {
  switch(action.type)  {
    case actionTypes.REQUEST_CONFIRMATION_RESPONSE:
      return requestConfirmationResponse(state, action)
    default:
      return state
  }
}

const requestConfirmationResponse = (state, action) => {
  return setDefault(action.payload, initialState)
}



// WEBPACK FOOTER //
// ./src/routes/requestConfirmation/modules/reducer.js